import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/HomePage";
import VestingPage from "./pages/VestingPage";
import LiquidityPage from "./pages/LiquidityPage";
import StakingPage from "./pages/StakingPage";
import SwapPage from "./pages/SwapPage";
import Layout from "./components/Layout";

const Router = () => {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" exact element={<Home />} />
                    <Route path="/home" exact element={<Home />} />
                    <Route path="/vesting" exact element={<VestingPage />} />
                    <Route path="/liquidity" exact element={<LiquidityPage />} />
                    <Route path="/staking" exact element={<StakingPage />} />
                    <Route path="/swap" exact element={<SwapPage />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    )
}

export default Router;